import React from 'react';
import './Sidebar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cursorDefault from '../../assets/cursors/cursor-default.png';
import cursorPointer from '../../assets/cursors/cursor-pointer.png';
import {
  faHandPaper,
  faMousePointer,
  faShapes,
  faMinus,
  faPencilAlt,
  faTextHeight,
  faInfoCircle,
  faImage,
  faSearch,
  faFile,
  faSave,
  faPenNib,
  faFillDrip,
} from '@fortawesome/free-solid-svg-icons';

const Sidebar = ({
  selectedTool,
  handleToolClick,
  triggerImageUpload,
  hoveredTool,
  handleMouseEnter,
  handleMouseLeave,
  imageInputRef,
  handleImageUpload,
}) => {
  const sidebarCursorDefault = `url(${cursorDefault}) 2 2, default`;
  const sidebarCursorPointer = `url(${cursorPointer}) 6 2, pointer`;

  return (
    <>
      <div
        className="sidebar collapsed"
        style={{ cursor: sidebarCursorDefault }}
        data-tour="editor-sidebar"
      >
        <button
          className={selectedTool === 'workspaceInfo' ? 'selected' : ''}
          onClick={() => handleToolClick('workspaceInfo')}
          title="Workspace Info (W)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-workspace-info"
        >
          <FontAwesomeIcon icon={faInfoCircle} />
        </button>

        <button
          className={selectedTool === 'hand' ? 'selected' : ''}
          onClick={() => handleToolClick('hand')}
          title="Grab (G)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-hand"
        >
          <FontAwesomeIcon icon={faHandPaper} />
        </button>

        <button
          className={selectedTool === 'select' ? 'selected' : ''}
          onClick={() => handleToolClick('select')}
          title="Select (V)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-select"
        >
          <FontAwesomeIcon icon={faMousePointer} />
        </button>

        <button
          className={selectedTool === 'shape' ? 'selected' : ''}
          onClick={() => handleToolClick('shape')}
          title="Shapes (S)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-shape"
        >
          <FontAwesomeIcon icon={faShapes} />
        </button>

        <button
          className={selectedTool === 'line' ? 'selected' : ''}
          onClick={() => handleToolClick('line')}
          title="Line (L)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-line"
        >
          <FontAwesomeIcon icon={faMinus} />
        </button>

        <button
          className={selectedTool === 'pencil' ? 'selected' : ''}
          onClick={() => handleToolClick('pencil')}
          title="Pencil (P)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-pencil"
        >
          <FontAwesomeIcon icon={faPencilAlt} />
        </button>

        <button
          className={selectedTool === 'pen' ? 'selected' : ''}
          onClick={() => handleToolClick('pen')}
          title="Pen Tool (N)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-pen"
        >
          <FontAwesomeIcon icon={faPenNib} />
        </button>

        <button
          className={selectedTool === 'text' ? 'selected' : ''}
          onClick={() => handleToolClick('text')}
          title="Text (T)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-text"
        >
          <FontAwesomeIcon icon={faTextHeight} />
        </button>

        <button
          className={selectedTool === 'bucket' ? 'selected' : ''}
          onClick={() => handleToolClick('bucket')}
          title="Paint Bucket"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-bucket"
        >
          <FontAwesomeIcon icon={faFillDrip} />
        </button>

        <button
          className={selectedTool === 'addImage' ? 'selected' : ''}
          onClick={() => handleToolClick('addImage')}
          title="Add Image (I)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-add-image"
        >
          <FontAwesomeIcon icon={faImage} />
        </button>

        <input
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          ref={imageInputRef}
          onChange={handleImageUpload}
        />

        <button
          className={selectedTool === 'zoom' ? 'selected' : ''}
          onClick={() => handleToolClick('zoom')}
          title="Zoom (+/-)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-zoom"
        >
          <FontAwesomeIcon icon={faSearch} />
        </button>

        <button
          className={selectedTool === 'addPage' ? 'selected' : ''}
          onClick={() => handleToolClick('addPage')}
          title="Add Page (A)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-add-page"
        >
          <FontAwesomeIcon icon={faFile} />
        </button>

        <button
          className={selectedTool === 'save' ? 'selected' : ''}
          onClick={() => handleToolClick('save')}
          title="Save (Ctrl+S)"
          style={{ cursor: sidebarCursorPointer }}
          data-tour="tool-save"
        >
          <FontAwesomeIcon icon={faSave} />
        </button>
      </div>
    </>
  );
};

export default Sidebar;